<template>
  <CustomUpdateDialog
    :dialogTitle="`ویرایش ${resourceTitle}`"
    :dialogId="`update-resource-dialog-${dialogId}`"
    noCloseOnBackdrop
    :isOkDisabled="isOkButtonDisabled"
    @ok="sendUpdateResourceRequest"
  >
    <BCol cols="12">
      <BRow class="mb-1">
        <BCol cols="12">
          <TextInput
            customRules="required|min:1"
            inputId="resource-title"
            inputLabel="عنوان منبع"
            inputPlaceholder="مقدماتی..."
            v-model="updateResourcePayload.title"
          ></TextInput>
          <BFormGroup label="تصویر نمایشی منبع" label-for="imageFile">
            <BFormFile
              v-model="updateResourcePayload.imageFile"
              ref="imageFile"
              id="imageFile"
              accept=".jpg,.jpeg,.png"
              @input="handleImageFile"
            ></BFormFile>
          </BFormGroup>
        </BCol>
        <BCol
          cols="12"
          class="position-relative"
          v-if="updateResourcePayload.imagePreview"
        >
          <BImg
            rounded
            class="custom-image"
            center
            fluid
            :src="updateResourcePayload.imagePreview"
          ></BImg>

          <BButton
            size="sm"
            variant="transparent"
            class="custom-delete-btn"
            @click="deletePreviewImage"
          >
            <FeatherIcon size="40" class="text-danger" icon="Trash2Icon" />
          </BButton>
        </BCol>
        <template v-if="defaultImage">
          <BCol cols="12">
            <hr />
          </BCol>
          <BCol cols="12" class="mt-1">
            <label> تصویر فعلی منبع </label>
            <div class="d-flex align-items-center justify-content-center">
              <BImg
                rounded
                class="custom-image mx-auto"
                fluid
                :src="`${baseUrl}/${defaultImage}`"
              ></BImg>
            </div>
          </BCol>
        </template>
      </BRow>
    </BCol>
  </CustomUpdateDialog>
</template>

<script>
export default {
  emits: ["refetch"],
  props: {
    dialogId: {
      type: [Number, String],
    },
    resourceDetails: {
      type: Object,
    },
    defaultImage: {
      type: String,
    },
  },
  watch: {
    resourceDetails: {
      immediate: true,
      handler(val) {
        if (val) {
          this.updateResourcePayload = JSON.parse(
            JSON.stringify(this.resourceDetails)
          );
        }
      },
    },
  },
  data() {
    return {
      isOkButtonDisabled: false,
      updateResourcePayload: {},
    };
  },
  methods: {
    handleImageFile() {
      if (this.updateResourcePayload && this.updateResourcePayload.imageFile) {
        this.updateResourcePayload.imagePreview = URL.createObjectURL(
          this.updateResourcePayload.imageFile
        );
      }
    },
    deletePreviewImage() {
      if (this.updateResourcePayload && this.updateResourcePayload.imageFile) {
        URL.revokeObjectURL(this.updateResourcePayload.imagePreview);
        this.updateResourcePayload.imagePreview = null;
        this.updateResourcePayload.imageFile = null;
        if (this.$refs.imageFile && this.$refs.imageFile) {
          this.$refs.imageFile.reset();
        }
      }
    },
    async sendUpdateResourceRequest() {
      try {
        this.isOkButtonDisabled = true;
        let _this = this;
        let updateResource = new UpdateResource(_this);
        updateResource.setFormData(
          helper.generateFormData(_this.updateResourcePayload)
        );
        await updateResource.sendFormData((res) => {
          if (res.data.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ویرایش شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "منبع با موفقیت ویرایش شد.",
              },
            });
            _this.updateResourcePayload = {};
            _this.$bvModal.hide(`update-resource-dialog-${this.dialogId}`);
            _this.$emit("refetch");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ویرایش نشد!",
                icon: "XIcon",
                variant: "danger",
                text:
                  res.data.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isOkButtonDisabled = false;
      }
      console.log(this.updateResourcePayload);
    },
  },
  computed: {
    resourceTitle() {
      if (this.resourceDetails && this.resourceDetails.title) {
        return this.resourceDetails.title;
      }
      return "";
    },
    baseUrl() {
      return process.env.VUE_APP_BASE_URL;
    },
  },
  components: {
    CustomUpdateDialog,
    BRow,
    BCol,
    BButton,
    BFormGroup,
    BFormFile,
    BImg,
    TextInput,
  },
};
import {
  BRow,
  BCol,
  BButton,
  BFormGroup,
  BFormFile,
  BImg,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import CustomUpdateDialog from "@/views/components/Utils/Dialogs/CustomUpdateDialog.vue";
import TextInput from "@/views/components/Utils/TextInput.vue";
import helper from "@/libs/Helper";
import { UpdateResource } from "@/libs/Api/Resources";
</script>
<style scoped>
.custom-image {
  max-height: 200px;
}
</style>
<style>
.custom-delete-btn {
  position: absolute !important;
  right: 0 !important;
  top: 0 !important;
}
</style>
